import React, { useEffect, useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, HeartIcon, ExternalLinkIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FoundationalGiftPopup() {
  // Default to Spanish since popup appears on landing page before language selection
  const isEs = true;
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const dismissed = sessionStorage.getItem('haa-gift-popup-dismissed');
    if (dismissed) return;
    // Show after a brief delay so the page has time to render
    const timer = setTimeout(() => setIsOpen(true), 800);
    return () => clearTimeout(timer);
  }, []);
  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem('haa-gift-popup-dismissed', '1');
  };
  const handleReadMore = () => {
    handleClose();
    setTimeout(() => {
      const el = document.getElementById('news');
      if (el) {
        const navbarHeight = 88;
        const pos = el.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: pos - navbarHeight,
          behavior: 'smooth'
        });
      }
    }, 300);
  };
  return <AnimatePresence data-id="element-2395">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={handleClose} data-id="element-2396">
          <motion.div initial={{
        opacity: 0,
        scale: 0.92,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.92,
        y: 20
      }} transition={{
        duration: 0.35,
        ease: [0.16, 1, 0.3, 1]
      }} className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-2397">
            {/* Image */}
            <div className="relative w-full h-56 sm:h-64 overflow-hidden" data-id="element-2398">
              <img src="https://cdn.magicpatterns.com/uploads/t6CDd8rFXEc7hF6yTp6k97/HonduranAmerican4.jpg" alt={isEs ? 'Presidente de la HAA Jay Miranda con la Directora Nubia Mendoza' : 'HAA President Jay Miranda with Director Nubia Mendoza'} className="w-full h-full object-cover object-center" data-id="element-2399" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" data-id="element-2400" />
              <button onClick={handleClose} className="absolute top-3 right-3 p-1.5 rounded-full bg-black/40 hover:bg-black/60 text-white transition-colors" aria-label="Close" data-id="element-2401">
                <XIcon className="w-4 h-4" data-id="element-2402" />
              </button>
              {/* Badge */}
              <div className="absolute bottom-4 left-4 right-4" data-id="element-2403">
                <div className="inline-flex items-center gap-1.5 bg-amber-500 text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider shadow-lg" data-id="element-2404">
                  <HeartIcon className="w-3.5 h-3.5" data-id="element-2405" />
                  {isEs ? 'Compromiso Fundacional' : 'Foundational Pledge'}
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-5 sm:p-6" data-id="element-2406">
              <h3 className="font-bebas text-2xl sm:text-3xl text-haa-navy tracking-wider leading-tight mb-2" data-id="element-2407">
                {isEs ? 'Donamos $10,000 Dólares USD (L266,000) a la Fundación para Niños con Cáncer' : "We Pledge $10,000 USD to the Children's Cancer Foundation"}
              </h3>
              <p className="font-nunito text-gray-600 text-sm leading-relaxed mb-4" data-id="element-2408">
                {isEs ? 'El Presidente de la HAA Jay Miranda visitó la Fundación Hondureña para el Niño con Cáncer y anunció una donación personal de $10,000 Dólares USD (L266,000) para apoyar a los niños que luchan contra el cáncer en Honduras.' : 'HAA President Jay Miranda visited the Fundación Hondureña para el Niño con Cáncer and announced a personal donation of $10,000 Dollars USD to support children fighting cancer in Honduras.'}
              </p>

              <div className="flex flex-col sm:flex-row gap-2" data-id="element-2409">
                <button onClick={handleReadMore} className="flex-1 inline-flex items-center justify-center gap-1.5 bg-haa-navy hover:bg-haa-blue text-white font-nunito font-bold text-sm px-5 py-2.5 rounded-xl transition-colors" data-id="element-2410">
                  {isEs ? 'Leer la Historia' : 'Read the Story'}
                </button>
                <button onClick={handleClose} className="flex-1 inline-flex items-center justify-center gap-1.5 bg-red-600 hover:bg-red-700 text-white font-nunito font-bold text-sm px-5 py-2.5 rounded-xl transition-colors" data-id="element-2411">
                  Cerrar Anuncio
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}